import { ICardMedia } from '../../components/CardMedia/interfaces';

import {Props} from "../../components/BlockWeAreTrusted/BlockWeAreTrusted";
import {loadPageContent} from "../../services/content/functions";
import {EnumUrlsPages} from "../../services/Enum";

interface PageContent {
  counters?: Props
}

export const pageContent = loadPageContent(EnumUrlsPages.about) as PageContent;

export const ListPrinciples = [
  'Наша ответственность — <br/>доставка товара',
  'Курьер — амбассадор вашего <br/>бренда',
  'Грамотный найм, обучение<br/> и система мотивации — залог<br/> успеха курьерской службы',
  'Счастливый покупатель —<br/> основа стабильности<br/> интернет-магазина',
];

export const ListMedia: ICardMedia[] = [
  {
    image: require('./img/media_oborot.svg').default,
    title: 'Dalli запустила услугу доставки из Москвы и Спб в города ЦФО',
    link: 'https://oborot.ru/news/kurerskaya-sluzhba-dalli-zapustila-uslugu-dostavki-iz-moskvy-i-sankt-peterburga-v-goroda-cfo-i160942.html',
  },
  {
    image: require('./img/media_retail-icon.svg').default,
    title: 'На что курьерской компании обратить внимание в первую очередь, чтобы сократить издержки?',
    link: 'https://www.retail.ru/rbc/pressreleases/na-chto-kurerskoy-kompanii-obratit-vnimanie-v-pervuyu-ochered-chtoby-sokratit-izderzhki/',
  },
  {
    image: require('./img/media_iz.png'),
    title: 'Названы способы избежать обмана в дни распродажи',
    link: 'https://iz.ru/1423093/2022-11-10/nazvany-sposoby-izbezhat-obmana-v-dni-rasprodazhi',
  },
  {
    image: require('./img/media_logirus.svg').default,
    title: 'Задержки «в наложке», мошенники на колесах, логистика без настроения',
    link: 'https://logirus.ru/tv/loginews/zaderzhki-v-nalozhke-moshenniki-na-kolesakh-logistika-bez-nastroeniya-loginews-54/',
  },
  {
    image: require('./img/media_kommersant.svg').default,
    title: 'Е-коммерсЪ в России: New Retail. New opportunities',
    link: 'https://events.kommersant.ru/events/e-kommers-v-rossii-23/',
  },
  {
    image: require('./img/media_vedomosti.svg').default,
    title: 'Перевозки посылок между РФ и СНГ выросли на десятки процентов',
    link: 'https://www.vedomosti.ru/business/articles/2023/05/15/974970-perevozki-posilok-mezhdu-rf-i-sng-v-aprele-virosli',
  },
];
export const SliderGalleryList: string[] = [
];
